<template>
  <div class="admin_Issue">
    <v-card>
      <v-toolbar flat color="white">
        <v-card-title>
          <v-btn color="indigo" dark class="mb-2" rounded small @click="back"><v-icon>mdi-arrow-left-bold</v-icon></v-btn>
          <v-divider class="mx-4" inset vertical></v-divider>
          {{ $t('dashboard_issue') }}
        </v-card-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" max-width="700px">
          <template v-slot:activator="{ on }">
            <v-btn color="red lighten-2" rounded small dark class="mb-2" v-on="on"  @click="addNew">{{ $t('dashboard_issue') }}</v-btn><!-- Filters To assist with Main Titles on the Front End -->
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-row class="px-6 py-3" align="center"> 
                  <span class="mr-4"><b>To:</b></span>
                  <v-menu v-model="menu" bottom right transition="scale-transition" origin="top left">
                    <template v-slot:activator="{ on }">
                      <v-chip pill v-on="on">
                        <v-avatar left>
                          <v-img src="@/assets/icon.png"></v-img>
                        </v-avatar>
                        <b>Convergeo Administrator</b>
                      </v-chip>
                    </template>
                  </v-menu>
                  <v-spacer></v-spacer>
                  <v-divider class="mx-4" inset vertical></v-divider>
                  <span class="mr-4"><b>From:</b></span>
                  <v-menu v-model="menu" bottom left transition="scale-transition" origin="top right">
                    <template v-slot:activator="{ on }">
                      <v-chip pill v-on="on">
                        <v-avatar left>
                          <!-- <v-img src="@/assets/icon.png"></v-img> -->
                          <v-icon>mdi-account</v-icon>
                        </v-avatar>
                        <b>{{user.name}}</b>
                      </v-chip>
                    </template>
                  </v-menu>
                </v-row>
                <v-divider></v-divider>
                <v-text-field full-width label="Subject" v-model="issue.subject" single-line prefix="Re: " counter="20"></v-text-field>
                <v-textarea full-width single-line label="Type Issue Here" v-model="issue.message" counter="120"></v-textarea>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="indigo darken-1" text @click="close">{{ $t('button_cancel') }}</v-btn>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <span v-on="on">
                    <a  @click="switcher">
                      <v-btn 
                        color="green darken-2" 
                        text
                        v-if="modal =='new'"  
                        @click="addIssue">
                        <v-icon>mdi-send</v-icon>
                      </v-btn>
                    </a>
                  </span>
                </template>
                <span>{{ $t('button_send') }} Report</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <span v-on="on">
                    <a  @click="switcher">
                      <v-btn 
                        color="indigo darken-1" 
                        text
                        v-if="modal =='edit'"  
                        @click="updateIssue">
                        <v-icon>mdi-send-check</v-icon>
                      </v-btn>
                    </a>
                  </span>
                </template>
                <span>{{ $t('button_update') }} Report</span>
              </v-tooltip>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
      <template>
        <v-container style="max-width: 700px;">
          <v-timeline dense clipped>
            <v-timeline-item class="mb-4" color="grey" icon-color="grey lighten-2" icon="mdi-account" small v-for="issue in issues" :key="issue.id">
              <v-row justify="space-between">
                <v-col cols="6">
                  <v-card-title class="text-right">
                    {{issue.subject}}
                  </v-card-title>
                  <v-card-text>
                    {{issue.message}}
                  </v-card-text>
                </v-col>
                <v-col cols="4">
                  <v-card-text>
                    {{issue.time}}
                  </v-card-text>
                </v-col>
                <v-col class="text-right" cols="2">
                  <v-icon small color="green" class="mr-2" @click="editIssue(issue)">
                    mdi-pencil
                  </v-icon>
                  <v-icon small color="orange" @click="deleteIssue(issue)">
                    mdi-delete
                  </v-icon>
                </v-col>
              </v-row>
            </v-timeline-item>
          </v-timeline>
        </v-container>
      </template>
    </v-card>
  </div>
</template>

<script>
  import {fb,db} from '@/firebase';
  
  export default {
    name : "admin_Issue",
    props: {
      msg: String
    },
    data: () => ({
      dialog: false,
      search: '',
      headers: [
        { text: 'Issue Title', align: 'left',value: 'subject'},
        { text: 'Issue From', value: 'user_name'},
        { text: 'Issue Message', value: 'message'},
        { text: 'Posted Time', value: 'time'},
        { text: 'Actions', value: 'action', sortable: false }
      ],
      issues: [],
      editedIndex: -1,
      issue: {
        subject: '',
        user_name: '',
        message: '',
        reply: '',
        time: ''
      },
      activeItem: null,
      modal: null
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'Report An Issue With Convergeo' : 'Edit Your Report About Convergeo'
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
    },

    firestore() {
      return {
        iss: db.collection('issues')
      }
    },

    methods: {
      back(){
        this.$router.go(-1)
      },
      
      goToSignIn(){
        this.$router.push('/signin/return')
      },

      switcher(){
        this.$router.push({ name: 'dashboard_issues_alt', params: { slug: this.item.slug }})
      },
      
      reset(){
        this.issue = {
          subject: '',
          user_name: '',
          message: '',
          reply: '',
          time: ''
        }  
      },

      addNew(){
        this.modal = 'new'
        this.reset()
        this.dialog = true
      },

      addIssue(){
        const time = (new Date()).toTimeString()
        db.collection('issues').add({
          subject: this.issue.subject,
          user_name: this.user.name,
          message: this.issue.message,
          reply: this.issue.reply,
          time: time,
          user: this.uid
        }).then(() => {
          /* eslint-disable */
          Toast.fire({
            type: 'success',
            title: 'Your Issue Has Been Sent!'
          })
          this.close()
        }).catch(err => {
            console.log(err);
        })
        /* eslint-enable */
      },
      
      updateIssue(){
        this.$firestore.iss.doc(this.issue.id).update(this.issue)
        /* eslint-disable */
        Toast.fire({
          type: 'success',
          title: 'Convergeo Issue updated successfully'
        })
        /* eslint-enable */
        this.close()
      },

      editIssue(item) {
        this.editedIndex = this.issues.indexOf(item)
        this.issue = Object.assign({}, item)
        this.modal = 'edit'
        this.dialog = true
      },

      deleteIssue(item) {
        /* eslint-disable */
        Swal.fire({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
          if (result.value) {
            this.$firestore.iss.doc(item.id).delete()            

            Toast.fire({
              type: 'success',
              title: 'Deleted successfully'
            })
          }
        })
        /* eslint-enable */
      }, 

      close () {
        this.dialog = false
        setTimeout(() => {
          this.issue = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      }
    },

    created(){
      this.uid =fb.auth().currentUser.uid

      db.collection('user').where('user_id','==',fb.auth().currentUser.uid).get()
      .then(snapshot=>{
        snapshot.forEach(doc => {
          this.user =doc.data(),
          this.user.id = doc.id
        })
      })

      db.collection('issues')
      .where('user','==',this.uid).get()
      .then(snapshot =>{
        snapshot.forEach(doc =>{
          let issue = doc.data()
          issue.id =  doc.id
          this.issues.push(issue) 
        })
      })
    }
  }
</script>
